const local = 'fr-FR';

export const formatPrice = (price) => {
  if (!price) return;
  return price.toLocaleString(local, {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const getStatutLabelByStatutLot = (statut) => {
  switch (statut) {
    case '3':
      return 'Réservé';
    case '5':
      return 'Non disponible';
    default:
      return 'Disponible';
  }
};

export const formatZones = (zones, lots) => {
  const result = [];
  if (!zones) return result;
  Object.keys(zones).forEach((key) => {
    if (key.endsWith('bis')) return;
    const lot = lots.find((l) => l.nom_ref === key);
    let shapes;
    let style;
    if (Array.isArray(zones[key])) {
      shapes = zones[key];
    } else if (typeof zones[key] === 'object') {
      shapes = zones[key].shapes;
      style = zones[key].style;
    }
    result.push({ key, lot, shapes, style });
  });
  return result;
};

export const formatSprites = (isTypeTerrain, mediaName, medias) => {
  let sprites = [];

  if (isTypeTerrain && mediaName !== 'Pieton' && medias.visites) {
    sprites = Object.values(medias.visites.medias).filter(
      (v) => v.type === 'visite',
    );
  }

  return sprites;
};

export const getColorByTypologie = (type, theme) => {
  switch (type?.toLowerCase()) {
    case 'terrain':
      return theme.palette.typologies.terrain;
    case 't1':
    case 'studio':
      return theme.palette.typologies.t1;
    case 't2':
      return theme.palette.typologies.t2;
    case 't3':
      return theme.palette.typologies.t3;
    case 't4':
      return theme.palette.typologies.t4;
    case 't5':
      return theme.palette.typologies.t5;
    case 't6':
      return theme.palette.typologies.t6;
    default:
      return theme.palette.typologies.default;
  }
};

export const formatLots = (lots) => {
  if (!lots) return;

  lots.map((lot) => {
    lot.prix_vente_total = formatParseFloat(lot.prix_vente_total);
    lot.surface = formatParseFloat(lot.surface);
    lot.surface_balcon = formatParseFloat(lot.surface_balcon);
    lot.surface_jardin = formatParseFloat(lot.surface_jardin);
    lot.surface_loggia = formatParseFloat(lot.surface_loggia);
    lot.surface_terrasse = formatParseFloat(lot.surface_terrasse);
  });

  return lots;
};

export const formatParseFloat = (number) => {
  if (!number) return 0;
  if (typeof number === 'number') return number;
  const newNumber = Number.parseFloat(number.replace(',', '.'));
  if (Number.isNaN(newNumber)) {
    return 0;
  }
  return newNumber;
};

export const getLotType = (type) => {
  switch (type) {
    case 'terrain':
      return 'Terrain';
    default:
      return type;
  }
};

export const getConfigSceneDefinition = (settings, media, mediaBaseUrl) => {
  const fps = media?.fps || settings?.maquette?.fps || 60;
  const loDef = settings?.maquette?.loDef || 'webp-720';
  const hiDef = settings?.maquette?.hiDef || 'webp-1080';
  const isTypeTerrain = settings?.maquette?.type === 'terrain';
  const hasAlpha = isTypeTerrain && media.path === 'Nu';
  const fullpath = `${mediaBaseUrl}/maquette/${media?.path}`;

  const fov = media?.fov || settings?.maquette?.fov;

  return { fps, loDef, hiDef, isTypeTerrain, hasAlpha, fullpath, fov };
};

export const getMediasListEtage = (mediasList) => {
  if (!mediasList) return {};

  return Object.values(mediasList).filter(
    (media) => media.path && media.path.includes('Etage'),
  );
};

export const getAllZonesEtages = (mediasList) => {
  if (!mediasList) return {};

  const mediasListEtage = getMediasListEtage(mediasList);

  return mediasListEtage.reduce((acc, media) => {
    const zones = media.zones ? media.zones : {};
    return { ...acc, ...zones };
  }, {});
};

export const getEtageByMediaName = (mediasList, mediaName) => {
  const mediasListEtage = getMediasListEtage(mediasList);
  return mediasListEtage.reduce((acc, media) => {
    const zones = media.zones ? media.zones : {};
    if (Object.keys(zones).includes(mediaName)) {
      return { ...media };
    }
    return acc;
  }, false);
};

export const getConditionsSettings = (settings) => {
  const hasAccueil = settings?.accueil?.show;
  const hasTemoins = settings?.temoins?.show;
  const hasVisite = settings?.visite;
  const hasGoogleMap = settings?.googleMaps?.show;
  const hasPhotoloc = settings?.photoloc?.show;
  const isTypeTerrain = settings?.maquette?.type === 'terrain';
  const defaultMedia = settings?.maquette?.defaultMedia;
  const showInfosLots = settings?.maquette?.showInfosLots;
  const showShareButton = settings?.maquette?.showShareButton;
  const showContact = settings?.contact?.show;
  const hasIllustrations = settings?.illustrations?.show;
  const contactApiUrl = settings?.contact?.apiUrl;

  return {
    hasAccueil,
    hasTemoins,
    hasVisite,
    hasGoogleMap,
    hasPhotoloc,
    isTypeTerrain,
    defaultMedia,
    hasIllustrations,
    showInfosLots,
    showShareButton,
    showContact,
    contactApiUrl,
  };
};

export const getLabelEtage = (etage) => {
  if (!etage) return;
  else if (etage.toLowerCase() === 'rdc') return 'RDC';
  return `Etage ${etage}`;
};

export const debounce = (callback, wait) => {
  let timer;
  return function (...args) {
    const context = this;

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      timer = null;
      callback.apply(context, args);
    }, wait);
  };
};
